App.controller('PackageCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', 'packageService', 'branchService', '$stateParams', 'dataUser', 'insuranceService', 'moment', function ($scope, $sce, $state, $http, $mdDialog, Config, packageService, branchService, $stateParams, dataUser, insuranceService, moment) {
    $scope.stateParams = $stateParams;

    $scope.page = 'insurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Moja deklaracja (wybierz pakiet)';
    $scope.$emit('step', $scope.step);

    insuranceService.last().then(function (data) {
        if (data.status === 200) {
            $scope.last = data.data;
            if ($scope.last) {
                $scope.link = 'root.home.insurance.list';
            } else {
                $scope.link = '';
            }
        }
        $scope.$emit('link', $scope.link);
    });

    // tmp, load from json, not from API
    packageService.dataPackageLists().then(function (data) {
        $scope.package = data.data.group;
    });

    $scope.userData = dataUser.getLocal();
    $scope.branch = JSON.parse($scope.userData).person.branch;


    var date = new Date();
    var dayOfMonth = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    var requiredDayOfMonth = 15;

    // wyjątek dla pierwszego miesiąca przystąpień (05.2018)
    if (month === 5 && year === 2018) {
        requiredDayOfMonth = 27;
    }

    if (dayOfMonth <= requiredDayOfMonth) {
        // to najbliższy
        var date = new Date(date.getFullYear(), date.getMonth() + 1);
        var formattedDate = moment(date).format('YYYY-MM-DD');
        $scope.proposedDate = formattedDate;
    } else {
        // to +1 miesiąc
        var date = new Date(date.getFullYear(), date.getMonth() + 2);
        var formattedDate = moment(date).format('YYYY-MM-DD');
        $scope.proposedDate = formattedDate;
    }

    console.log($scope.proposedDate);

    function initCloseInsurance() {
        var dateNow = moment().toDate();
        var dateTo = moment('2019-10-21').toDate();
        dateTo.setHours(0, 0, 0, 0);

        if (dateTo.getTime() <= dateNow.getTime()) {
            $state.go('root.health.start');
        }
    }

    initCloseInsurance();

}]);
